import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

function Video() {
  const [textRef, textVisible] = useScrollAnimation();

  return (
    <div className="video-wrapper">
      <div className="video container">
        <video autoPlay loop muted playsInline className="video-background">
          <source src="/video.mp4" type="video/mp4" />
        </video>
        <h2
          ref={textRef}
          className={`clr-white fs-1000 uppercase video-text ${
            textVisible ? "animate-in" : ""
          }`}
        >
          WHERE PRECISION MEETS POWER
        </h2>
      </div>
    </div>
  );
}

export default Video;
